import { ref, watch } from '@vue/composition-api'
import { measureUnitsListed } from '@/constants/measureUnits'

export default {
  name: 'MeasurementsInput',
  props: {
    solo: Boolean,
    value: [Object, String],
    items: Array,
    errorMessages: Array,
    placeholder: String,
    label: String,
    clearable: Boolean,
    hideDetails: Boolean,
    disabled: Boolean,
  },
  setup(props) {
    const inputValue = ref(null)
    const measureUnits = measureUnitsListed()
    const readonly = ref(true)

    watch(() => props.value, () => {
      if (!props.value) return
      const { value } = props
      const { text } = measureUnits.find(measure => measure.value === value)
      inputValue.value = { value, text }
    }, { immediate: true })


    return {
      inputValue, measureUnits, readonly,
    }
  },
}
